import React, { useMemo } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import PropTypes from 'prop-types';
import _ from 'lodash'
import { getOptions, getSelectedValue } from './helper';
import SelectVirtualized from '../../../../../../../../components/Select/Virtualized';

const FieldProviderServiceId = ({ providerServiceId, field_type, modal, form, list, options, name, onChange, refill }) => {
  const { subscription_type, service_id } = form;
  const selectOptions = useMemo(() => getOptions(list, options, modal, subscription_type), [list, options, modal, subscription_type]);
  const selectedValue = useMemo(() => getSelectedValue(selectOptions, providerServiceId), [selectOptions, providerServiceId]);
  const selectLabel = 'Service';

  const onChangeServiceSelect = (selected) => {
    const { value } = selected;
    onChange(value);
  };

  const onChangeServiceText = (value) => {
    onChange(value);
  }

  return (
    <FormGroup className="form-group__provider-service-id">
      <ControlLabel>{selectLabel}</ControlLabel>
      {(() => {
        switch (field_type) {
        case 'select':
          return (
            <>
              <SelectVirtualized
                components={{ IndicatorSeparator: null }}
                onChange={onChangeServiceSelect}
                name={refill ? 'refill_provider_service_id' : name}
                noOptionsMessage={() => 'Service not found'}
                hideSelectedOptions={false}
                isFocused={false}
                value={selectedValue}
                options={selectOptions}
                placeholder={`Choose ${selectLabel}`}
              />
              {providerServiceId && _.isNull(selectedValue) && service_id ? <small className="text-danger">A service was deleted or disabled by provider</small> : null }
            </>
          );
        case 'text':
          return (
            <FormControl
              type="text"
              id={name}
              name={refill ? 'refill_provider_service_id' : name}
              key={name}
              value={providerServiceId || ''}
              onChange={(e) => onChangeServiceText(e.target.value)}
            />
          );
        default:
          return null;
        }
      })()}
    </FormGroup>
  )
};

FieldProviderServiceId.propTypes = {
  providerServiceId: PropTypes.any,
  list: PropTypes.any,
  field_type: PropTypes.string,
  modal: PropTypes.object,
  form: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  refill: PropTypes.bool,
}

export default FieldProviderServiceId;
